import { WEBSITE_URL } from '@/config-global';
import { ResultOk, Store } from '@repo/common/types';
import ky from 'ky';

export type StoreSearchResponse = Pick<Store, 'urlSlug' | 'name'>;

const httpClient = ky.extend({
  prefixUrl: WEBSITE_URL,
  throwHttpErrors: false,
});

export const endpoints = {
  stores: {
    root: 'api/stores',
    search: 'api/stores/search',
  },
};

export async function seachForStore(text: string) {
  const searchParams = new URLSearchParams({ text });
  const data = await httpClient
    .get(endpoints.stores.search, { searchParams })
    .json<ResultOk<StoreSearchResponse[]>>();

  if (data.status === 'ok') {
    return data.data;
  }

  return { values: [], total: 0 };
}
